var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-index-box margin-top"},[_c('img',{attrs:{"src":require("../../../assets/img/mobile/mobile-index-text.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../../assets/img/mobile/mobile-index.png"),"alt":""}}),_c('div',{staticClass:"next-btn",on:{"click":function($event){return _vm.toNext(1)}}},[_vm._v("下一页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }